import gql from 'graphql-tag';
import Client from "../services/Client";
import Cookie from "../services/Cookie";

const CommonAction = {

    /**
     * @purpose: fetch country list
     * @author: Arijit Deb Roy
     * @return: <JSON>
     */
    listCountry(status='active') {
        const LIST_COUNTRY = gql`
                query listCountry($token: AccessToken!, $input: CountryListInput!){
                  listCountry(token: $token, input: $input){
                    code
                    status
                    message
                    data{
                      totalCount
                      countries{
                        countryId
                        name
                        dialCode
                        code
                        currencyId
                        otherJson
                        status
                        createdBy
                        updatedBy
                        createdAt
                        updatedAt
                      }
                    }
                  }
                }
            `;
        return Client.query({
            query: LIST_COUNTRY,
            variables: {
                input: {
                    status: status,
                },
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                }
            }
        });
    },

    /**
     * @purpose: fetch anonymous course list
     * @author: Arijit Deb Roy
     * @return: <JSON>
    */
    anonymousCourseList() {
        const LIST_COURSE = gql`
          query anonymousCourseList($input: UserDetailsInput!) {
            anonymousCourseList(input: $input) {
              code
              status
              message
              data{
                courseId
                courseName
                status
                courseDescription
              }
            }
          }
        `;
        return Client.query({
            query: LIST_COURSE,
            variables: {
                input: {
                    excludeCourseIds: process.env.NEXT_PUBLIC_EXCLUDE_COURSE_IDS.split(','),
                },
            }
        });
    },



    /**
     * @purpose: get course wise exam dates
     * @author: Arijit Deb Roy
     * @return: curseId: int
     */
    getExamDateList(courseId, examDateStatus='active') {
        const GET_EXAM_DATES = gql`query fetchExamDate($token: AccessToken!, $input: ExamDateFetchInput!) {
              fetchExamDate(token: $token, input: $input) {
                code
                status
                message
                data {
                  courseExamDateId
                  courseId
                  examDate
                  examDateStatus
                  createdAt
                  createdBy
                }
              }
            }`;
        return Client.query({
            query: GET_EXAM_DATES,
            variables: {
                input: {
                    courseId: courseId,
                    examDateStatus: examDateStatus,
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 0
                }
            }
        });
    },

    /**
     * @purpose: Save Bug Report 
     * @author: Susanta Chakraborty
     * @return: void
     */
    saveBugReport(inputObj) {
        const SAVE_BUG = gql`
        mutation bugRepoprtSaveUser($token:AccessToken!,$input:SaveUserBugReportInput!) {
          bugRepoprtSaveUser(token:$token, input: $input) {
            code
            status
            message
          }
        }
      `;
        return Client.mutate({
            mutation: SAVE_BUG,
            variables: {
                token: {
                    accessToken: Cookie.getCookie('_token'),
                    accessRole: 6
                },
                input: {
                    userId: inputObj.userId,
                    userName: inputObj.userName,
                    userEmail: inputObj.userEmail,
                    title: inputObj.title,
                    type: inputObj.type,
                    url: inputObj.url,
                    description: inputObj.description,
                    reportFileId: inputObj.reportFileId
                },
            }
        })
    }
}

export default CommonAction;
